import React from "react";
import { useNavigate } from "react-router-dom";
/** Services Import */
import IndexedDb from "../../services/IndexedDb/IndexedDb";
/** Components Import */
import { Nav, Navbar, NavDropdown, Offcanvas } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
/** Icons Import */
import { faRightFromBracket } from "@fortawesome/free-solid-svg-icons";

function Sidebar({ title = "", items = [], show, onHide = () => {} }) {
  const navigate = useNavigate();

  const ChangeOffcanvas = () => {
    onHide();
  };

  return (
    <Navbar.Offcanvas
      className="custom-offcanvas"
      placement="end"
      show={show}
      onHide={ChangeOffcanvas}
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title className="custom-offcanvas-head-title">
          {title}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Nav className="justify-content-end flex-grow-1 pe-3">
          {items.map((item, index) => {
            return (
              <React.Fragment key={index}>
                <Nav.Link
                  className="custom-offcanvas-nav-link pt-3"
                  onClick={() => {
                    item.onClick();
                    ChangeOffcanvas();
                  }}
                >
                  <FontAwesomeIcon
                    className="custom-offcanvas-nav-icon pe-2"
                    icon={item.icon}
                  />
                  {item.text}
                </Nav.Link>
                <div className="custom-offcanvas-divider" />
              </React.Fragment>
            );
          })}
          <Nav.Link
            className="custom-offcanvas-nav-link pt-3"
            onClick={async () => {
              await IndexedDb.ClearDb("AuthList");
              await IndexedDb.ClearDb("LoginInfo");
              await IndexedDb.ClearDb("MenuList");
              navigate("/");
              ChangeOffcanvas();
            }}
          >
            <FontAwesomeIcon className="pe-2" icon={faRightFromBracket} />
            Logout
          </Nav.Link>
        </Nav>
      </Offcanvas.Body>
    </Navbar.Offcanvas>
  );
}

export default Sidebar;
